import { gql } from "@apollo/client"

export const GET_DISTRICT = gql`
  query getDistrict($id: String!) {
    district {
      getDistrict(id: $id) {
        id
        name
        state
        organizationId
        sfid
        isACTDistrict
      }
    }
  }
`

export const GET_DISTRICTS = gql`
  query getDistricts($data: DistrictListInput!) {
    district {
      getDistricts(data: $data) {
        districts {
          id
          name
          state
          organizationId
          sfid
          isACTDistrict
        }
        paginationMeta {
          count
          hasNextPage
          hasPrevPage
          page
          pageSize
        }
      }
    }
  }
`
